import React, { Component } from 'react';
import { createCookie } from '../../components/common/Cookie.js';
import { Cookies } from '../../constants';
import { segmentEventPush, getProductItemPDP } from '../../modules/ga/GTMdatalayer';

class PincodeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidPincodeErrorMsg: '',
      pincode: props.edd.activePincode || ''
    };
    this.pincodeInputRef = React.createRef();
    // this.validatePincode = debounce(this.validatePincode, 2000);
  }

  componentDidMount() {
    const { newDesignLuxe } = this.props;
    const { pincode } = this.state;
    if (newDesignLuxe) {
      const getEddParameters = this.getEddParameters();
      this.handleGtmEventPush({
        ...getEddParameters,
        eventName: 'edd_initiate',
        label: 'initiate'
      });
    }
  }

  validatePincode = e => {
    const { pincode } = this.state;
    return (
      pincode.length > 6 ||
      pincode.length < 6 ||
      (!pincode.match(/^\d+/) && parseFloat(pincode) != parseInt(pincode)) ||
      isNaN(pincode)
    );
  };

  updatePincode = e => {
    let {
      target: { value: pincode = '' }
    } = e;
    if (pincode.length > 6) {
      pincode = pincode.slice(0, 6);
    }
    pincode = pincode.replace(/[e\+\-\.]/gi, '');
    this.setState({
      pincode,
      invalidPincodeErrorMsg: undefined
    });
  };

  getEddParameters = () => {
    const {
      edd: { activePincode, eddDetails, isEDDFetching },
      selectedSizeCode
    } = this.props;
    let productSpecificEDDDetails = {};

    if (activePincode && selectedSizeCode && eddDetails[activePincode]) {
      productSpecificEDDDetails = eddDetails[activePincode][selectedSizeCode];
      if (!productSpecificEDDDetails || Object.keys(productSpecificEDDDetails).length === 0) {
        return null;
      }
    }
    const { codEligible, servicability, eddUpper, eddLower } = productSpecificEDDDetails || {};
    return { codEligible, activePincode, servicability };
  };

  fetchDeliveryDetails = e => {
    e.preventDefault();
    e.stopPropagation();
    const { newDesignLuxe, selectedSizeCode } = this.props;
    if (this.validatePincode()) {
      this.setState(
        {
          invalidPincodeErrorMsg: 'Invalid Pincode'
        },
        () => {
          if (newDesignLuxe) {
            this.handleGtmEventPush({
              eventName: 'edd_error',
              label: `error - ${this.state.invalidPincodeErrorMsg}`
            });
          }
          if (this.pincodeInputRef.current) {
        this.pincodeInputRef.current.focus();
      }
        }
      );
      return;
    } else {
      const { pincode } = this.state;
      const now = new Date();
      const time = now.getTime();
      const expireTime = time + 15811200000; // 180 days
      now.setTime(expireTime);
      // Add Secure flag for all environments except localhost
      const isLocalhost = typeof location !== 'undefined' && (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
      const secureFlag = isLocalhost ? '' : '; Secure';
      document.cookie = `PC= ${pincode}; expires=${now.toGMTString()}; path=/${secureFlag}`;
      // createCookie(Cookies.PINCODE, pincode, 180);
      if(this.props.returnCodCommunicationPdpEnabled){
        this.props.fetchProductServiceability();
      }
      this.props.fetchDeliveryDetails(pincode).then(({ pinCode, servicability }) => {
        if (servicability === false) {
          if (newDesignLuxe) {
            const getEddParameters = this.getEddParameters();
            this.handleGtmEventPush({
              ...getEddParameters,
              eventName: 'edd_error',
              label: `error - Delivery not available - ${pinCode}`
            });
          } else {
            window.ga &&
              window.ga('send', {
                hitType: 'event',
                eventCategory: 'buttonTap',
                eventAction: 'EDD on PDP',
                eventLabel: `Delivery not available - ${pinCode}`
              });
          }
        }

        segmentEventPush({
          event: 'Delivery And Return Details Viewed',
          cod_text: '',
          delivery_picode: pincode,
          priority_delivery_date: '',
          priority_delivery_fees: '',
          priority_delivery_flag: true,
          priority_delivery_order_by_date: '',
          products: [
            {
              ...getProductItemPDP(this.props?.productData),
              product_return_window: this.props?.productData?.fnlProductData?.returnWindow ?? 0,
              product_exchange_window: this.props?.productData?.fnlProductData?.returnWindow ?? 0
            }
          ],
          rush_delivery_date: '',
          rush_delivery_fees: '',
          rush_delivery_flag: '',
          rush_order_by_date: '',
          screen_name: 'PDP screen',
          screen_source: `Delivery not available - ${pinCode}`,
          size_selected_flag: selectedSizeCode ? true : false,
          standard_delivery_date: ''
        });
      });
    }
  };

  handleGtmEventPush = ({ codEligible, servicability, activePincode, eventName, label }) => {
    const { luxeEventPush } = this.props;
    let luxeEventObj = {};
    if (eventName === 'edd_error') {
      luxeEventObj = {
        eventName,
        event_action: 'estimate delivery date',
        event_label: label
      };
    } else {
      luxeEventObj = {
        eventName,
        event_action: 'estimate delivery date',
        event_label: label,
        pincode: activePincode,
        cod_eligible: codEligible ? codEligible.toString() : '',
        servicable: servicability,
        isViewProductDetails: 'no'
      };
    }
    luxeEventPush(luxeEventObj);
  };

  render() {
    const { pincode = '', invalidPincodeErrorMsg } = this.state;
    const {
      edd: { isEDDFetching },
      isMobile,
      luxeEventPush
    } = this.props;
    return (
      <div className="edd-pincode-modal">
        <label className="edd-pincode-modal-header" for="edd-pincode-modal-input">Enter Pincode *</label>
        <form onSubmit={this.fetchDeliveryDetails}>
          <div className="edd-pincode-modal-form-container">
            <input
              ref={this.pincodeInputRef}
              id="edd-pincode-modal-input"
              className="edd-pincode-modal-text"
              aria-describedby='edd-pincode-modal-error-msg'
              type="number"
              name="pincode"
              value={pincode}
              onKeyDown={evt =>
                (evt.key === 'e' || evt.key === '+' || evt.key === '-' || evt.key === '.') &&
                evt.preventDefault()
              }
              pattern="[0-9]"
              onChange={this.updatePincode}
            />
            <span id="edd-pincode-modal-error-msg" className="edd-pincode-modal-text-error">{invalidPincodeErrorMsg}</span>

            <button
              className="edd-pincode-modal-submit-btn"
              type="submit"
              disabled={(invalidPincodeErrorMsg && invalidPincodeErrorMsg.length) || isEDDFetching}
            >
              {isMobile ? 'Check' : 'CONFIRM PINCODE'}
              <span>{isEDDFetching && '...'}</span>
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default PincodeForm;
